<template>
  <div>
    <vxe-modal
      :zIndex="10"
      v-model="modalData"
      title="Select Exim Document for Incoming Warehouse"
      width="80%"
      height="85%"
      show-zoom
      resize
    >
      <template #default>
        <el-row>
          <el-col :span="12">
            <h3 class="mb-3">{{ $t("dokBCList") }}</h3>
            <p>Untuk Pencarian Data Bisa langsung filter pada table</p>
          </el-col>
          <el-col :span="6" :offset="6">
            <el-checkbox v-model="cariByKode"> Cari By Kode</el-checkbox>
            <el-input
              v-if="cariByKode"
              v-model="cariKode"
              size="mini"
              placeholder="Masukkan Kode"
              class="input-with-select"
            >
              <el-button
                @click="searchIncomingByKode"
                slot="append"
                type="primary"
                icon="el-icon-search"
              ></el-button>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-button
              class="mb-5"
              type="primary"
              @click="selectAllData()"
              size="mini"
            >
              Pilih Semua Data
            </el-button>
          </el-col>
          <el-col :span="6">
            <el-checkbox v-model="cariByDokumen">
              Cari By Jenis Dokumen</el-checkbox
            >
            <el-select
              v-if="cariByDokumen"
              size="mini"
              style="width: 40%; margin-bottom: 10px"
              v-model="cariDokumen"
              filterable
              placeholder="Select"
            >
              <el-option
                v-for="item in optionDokumen"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              @click="searchByDokumen"
              class="ml-3"
              size="mini"
              v-if="cariByDokumen"
              type="primary"
              icon="el-icon-search"
              circle
            ></el-button>
          </el-col>
        </el-row>

        <vxe-table
          :loading="loadingTableDokSelect"
          empty-text="Empty Data "
          keep-source
          border
          resizable
          show-overflow
          show-header-overflow
          ref="tableDokumen"
          height="400"
          size="mini"
          row-key
          highlight-hover-row
          highlight-current-row
          :row-config="{ isCurrent: true, isHover: true, height: 35 }"
          :column-config="{ resizable: true }"
          :data="dataDokumen"
          :mouse-config="{ selected: true }"
          :radio-config="{}"
          :keyboard-config="{
            isArrow: true,
            isDel: true,
            isEnter: true,
            isTab: true,
            isEdit: true,
          }"
          :edit-config="{
            trigger: 'dblclick',
            mode: 'cell',
            showStatus: true,
          }"
          :scroll-y="{ mode: 'wheel' }"
          @filter-change="changeFilterDokumen"
        >
          <vxe-column type="seq" fixed="left" width="60"></vxe-column>

          <vxe-column
            sortable
            align="center"
            header-align="center"
            width="150"
            field="pilh"
            title="SELECT"
          >
            <template #default="{ row }">
              <el-button
                type="primary"
                @click="radioDokumenSelect(row)"
                size="mini"
              >
                Select
              </el-button>
            </template>
          </vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            align="left"
            header-align="center"
            width="150"
            field="noReg"
            :title="$t('noRegi').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            width="100"
            align="center"
            header-align="center"
            field="kodeSupplier"
            :title="$t('kodeSupplier').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            width="150"
            align="left"
            header-align="center"
            field="namaSupplier"
            :title="$t('nameSupplier').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            width="150"
            align="left"
            header-align="center"
            field="noAju"
            :title="$t('noAju').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            width="150"
            align="left"
            header-align="center"
            field="noInvoice"
            :title="$t('noInvoice').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            width="150"
            align="left"
            header-align="center"
            field="noSuratJalan"
            :title="$t('noSuratJalan').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            width="150"
            align="left"
            header-align="center"
            field="noAwb"
            :title="$t('noAwb').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            width="150"
            align="left"
            header-align="center"
            field="noPacking"
            :title="$t('noPacking').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            width="150"
            align="center"
            field="tglDokumen"
            title="DATE"
          >
            <template #default="{ row }">
              {{ $formatDatemoment(row.tglDokumen) }}
            </template>
          </vxe-column>

          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            width="150"
            align="center"
            field="idDokumen"
            :title="$t('customType').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            width="150"
            align="center"
            field="noUrut"
            :title="$t('noDocs').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            width="150"
            align="center"
            field="status"
            :title="$t('status').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            width="150"
            align="center"
            field="user"
            :title="$t('user').toUpperCase()"
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
        </vxe-table>
        <vxe-form title-align="right" title-width="60">
          <vxe-form-item align="center" span="24">
            <template #default>
              <vxe-button type="reset" @click="modalData = false">{{
                $t("close")
              }}</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
export default {
  props: ["isSubkon"],
  data() {
    return {
      isPpbkb: false,
      optionDokumen: [
        {
          text: "BC 23",
          value: "23",
        },
        {
          text: "BC 40",
          value: "40",
        },
        {
          text: "BC 262",
          value: "262",
        },
        {
          text: "BC 27",
          value: "27",
        },
      ],
      cariDokumen: "",
      cariKode: "",
      cariByDokumen: false,
      cariByKode: false,
      dataDokumen: [],
      loadingTableDokSelect: false,
      modalData: false,
    };
  },

  methods: {
    selectAllData() {
      this.dataDokumen.forEach((row) => {
        this.$emit("dokumenSelect", row);
      });
    },
    async searchIncomingByKode() {
      if (!this.cariKode)
        return this.notifValidasi("Silahkan masukkan kode barang", true);
      this.loadingTableDokSelect = true;
      let get = await this.$api.get(
        this.$serviceApi + "exim/notequalsdokumenbykode",
        {
          params: { kodeBarang: this.cariKode, isSubkon: this.isSubkon },
        }
      );
      this.dataDokumen = get.data.content;
      this.loadingTableDokSelect = false;
    },
    async searchByDokumen() {
      if (!this.cariDokumen) {
        return this.notifValidasi("Silahkan Isi Jenis Dokumen", true);
      }
      let arr = [{ datas: [this.cariDokumen], field: "idDokumen" }];
      this.getDokumen(arr);
    },

    radioDokumenSelect(row) {
      this.$emit("dokumenSelect", row);
    },
    async getDokumen(filterList) {
      try {
        let endpoint;

        if (this.$store.state.ppbkbMenu && this.isPpbkb) {
          endpoint = `${this.$serviceApi}exim/notequalsppbkb`;
        } else {
          endpoint = `${this.$serviceApi}exim/notequalsdokumen`;
        }

        this.loadingTableDokSelect = true;

        if (!filterList) filterList = [];
        let dataSearch = {};
        for (let elm of filterList) {
          dataSearch[elm.field] = elm.datas[0];
        }

        dataSearch.isSubkon = this.isSubkon;
        let get = await this.$api.get(endpoint, {
          params: dataSearch,
        });

        // let tglawal = moment(this.tglDocAwal).format("yyyy-MM-DD");
        // let tglakhir = moment(this.tglDocAkhir).format("yyyy-MM-DD");
        // const response = await this.$api.get(
        //   `/api/v1/warehouse/dokumenmasuk/notequals?start=${tglawal}&end=${tglakhir}`
        // );
        this.dataDokumen = get.data.content;
        this.loadingTableDokSelect = false;
      } catch (error) {
        this.loadingTableDokSelect = false;
        console.log(error);
      }
    },
    async changeFilterDokumen({
      column,
      property,
      values,
      datas,
      filterList,
      $event,
    }) {
      this.getDokumen(filterList);
    },

    openModal(modalType) {
      this.modalData = true;
      if (this.dataDokumen.length) {
        this.dataDokumen = [];
      }
      if (modalType == "ppbkb") {
        this.isPpbkb = true;
        this.getDokumen();
      }
      if (modalType == "dokBc") {
        this.isPpbkb = false;
        this.getDokumen();
      }
    },
    closeModal() {
      this.modalData = false;
    },
    async getBarang(jenis) {
      console.log(jenis);
    },
    sendData(row) {
      this.$emit("sendData", row);
    },
  },
  mounted() {
    this.getDokumen();
  },
};
</script>
<style></style>
